var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"dropzoneElement",staticClass:"text-center emptyDropTarget OffWhiteBackground LightNeutralColourBackgroundHover marginal-bottom paddedCell"},[_c('h3',{staticClass:"padded-top text-muted"},[_vm._v("Drop file here")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }